import { render, staticRenderFns } from "./illegal.vue?vue&type=template&id=c11ff5e8&scoped=true&"
import script from "./illegal.vue?vue&type=script&lang=js&"
export * from "./illegal.vue?vue&type=script&lang=js&"
import style0 from "./illegal.vue?vue&type=style&index=0&id=c11ff5e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11ff5e8",
  null
  
)

export default component.exports